import { Select, styled } from "@mui/material";

type CustomSelectProps = {
  width: string;
  height: string;
};

const CustomSelect = styled(Select)<CustomSelectProps>(
  ({ width, height }) => ({
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e0e0e0",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#000",
    },
    "& .MuiSelect-select": {
      padding: "clamp(6px, 1vw, 10px) clamp(10px, 2vw, 16px)",
    },

    width: width ,
    height: height,
    fontSize: "clamp(0.7rem, 1.5vw, 0.95rem)", 
    borderRadius: "999px", 
  })
);

export default CustomSelect;
